export type DataWithStatus<TData> = { isSuccess: boolean; data?: TData };

export const mapToDataWithStatus = <TData>(data: TData | undefined, isSuccess: boolean): DataWithStatus<TData> => {
    if (!isSuccess) return { isSuccess };
    return { isSuccess, data };
};
